
import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useNavigate } from 'react-router';

import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Switch, IconButton, TableFooter, TablePagination, Typography, Button, Grid, Dialog, DialogActions, DialogContent, TextField, CircularProgress, Paper } from '@mui/material';

import EditIcon from '@mui/icons-material/Edit';
import UndoIcon from '@mui/icons-material/Undo';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { usePages } from '../../hooks/usePages';
import { useFilter } from '../../hooks/useFilter';

import { RootState } from '../../store';
import { openSnackbar } from '../../store/slices/SnackbarSlice';

import { TablePaddingStyle, TableTheadStyle } from '../../styles/TableStyle';
import { DialogActionsStyle, DialogContentStyle } from '../../styles/DialogStyle';

import { Layout } from '../../components/Layout';
import { SearchTextField } from '../../components/SearchTextField';

import { TipoAudienciaProps } from '../../interfaces/catalogos/TipoAudienciaInterface';

import { ActualizarTipoAudiencia, AgregarTipoAudiencia, TipoAudiencias } from '../../connections/catalogos/TipoAudienciaConnection';

export const TipoAudienciaPage = () => {

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const { administrador, coordinador } = useSelector( ( state: RootState ) => state.auth );

    const [TipoAudiencia, setTipoAudiencia] = useState<TipoAudienciaProps[]>( [] );

    const [openDialog, setOpenDialog] = useState( false );
    const [loading, setLoading] = useState( false );
    const [loadingData, setLoadingData] = useState( true );

    const [idTipoAudiencia, setIdTipoAudiencia] = useState( 0 );
    const [descripcion, setDescripcion] = useState( '' );
    const [duracion, setDuracion] = useState( 30 );

    const { page, rowsPerPage, handleChangePage, handleChangeRowsPerPage, resetPage } = usePages( 5 );

    const { filtro, setFiltro, dataFiltrada } = useFilter( TipoAudiencia, ( item, filtro ) => item.descripcion?.toLowerCase().includes( filtro.toLowerCase() ) );

    const handleChangeChecked = async ( activo: boolean, oral: boolean, tradicional: boolean, medioPreparatorio: boolean, citaSentencia: boolean, id: number ) => {

        const TipoAudienciaselected = TipoAudiencia.find( (elem) => elem.idTipoAudiencia === id );

        if ( TipoAudienciaselected ) {

            await ActualizarTipoAudiencia({ ...TipoAudienciaselected, activo, oral, tradicional, medioPreparatorio, citaSentencia }).then( resp => {

                if ( resp.idTipoAudiencia ) {

                    var newArray = TipoAudiencia.map( (elem) => {

                        if ( elem.idTipoAudiencia === id ) {
                            elem.activo = activo;
                            elem.oral = oral;
                            elem.tradicional = tradicional;
                            elem.medioPreparatorio = medioPreparatorio;
                            elem.citaSentencia = citaSentencia;
                        }

                        return elem;
                    });

                    setTipoAudiencia( newArray );

                    dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                }

            });
        }

    }

    const handleGuardar = async () => {

        if ( idTipoAudiencia !== 0 ) {

            const TipoAudienciaselected = TipoAudiencia.find( (elem) => elem.idTipoAudiencia === idTipoAudiencia );

            if ( TipoAudienciaselected ) {

                setLoading( true );

                await ActualizarTipoAudiencia({ ...TipoAudienciaselected, descripcion, duracion }).then( resp => {

                    if ( resp.idTipoAudiencia ) {

                        setTimeout(() => {

                            var newArray = TipoAudiencia.map( (elem) => {

                                if ( elem.idTipoAudiencia === idTipoAudiencia ) {
                                    elem.descripcion = descripcion;
                                    elem.duracion = duracion;
                                }

                                return elem;
                            });

                            setTipoAudiencia( newArray );
                            setOpenDialog( false );
                            setLoading( false );

                            dispatch( openSnackbar({ message: 'Se actualizó el registro correctamente', variant: 'success' }));

                        }, 700);

                    }

                });
            }

        }
        else {

            const aplicacionAdd: TipoAudienciaProps = {
                idTipoAudiencia: 0,
                descripcion,
                duracion,
                oral: false,
                tradicional: false,
                medioPreparatorio: false,
                citaSentencia: false,
                activo: true,
            }

            setLoading( true );

            await AgregarTipoAudiencia( aplicacionAdd ).then( resp => {

                if ( resp.idTipoAudiencia ) {

                    setTimeout(() => {

                        setTipoAudiencia( [...TipoAudiencia, resp] );
                        setOpenDialog( false );
                        setLoading( false );

                        dispatch( openSnackbar({ message: 'Se agregó el tipo de audiencia correctamente', variant: 'success' }));

                    }, 700);

                }

            });

        }

    }

    useEffect(() => {

        async function obtener() {

            setLoadingData( true );
            setTipoAudiencia( [] );

            await TipoAudiencias().then( resp => {

                setTimeout(() => {

                    setTipoAudiencia( resp );
                    setLoadingData( false );

                }, 700);

            });

        }

        obtener();

    }, [])

    return (

        <Layout breadcrumbs={ [ { text: 'Administración' }, { text: 'Catálogos' }, { text: 'Tipo de audiencia' } ] } backgroundPaper={ false }>

            <Grid container spacing={ 3 } >

                <Grid size={{ xs: 6 }} textAlign={ 'start' }>

                    {
                        ( administrador || coordinador )
                        &&
                            <Button startIcon={ <UndoIcon /> } color='secondary' variant='text' sx={{ mt: 1 }} onClick={ () => navigate( '/' ) }>
                                Regresar
                            </Button>
                    }

                </Grid>

                <Grid size={{ xs: 6 }} textAlign={ 'end' }>

                    <Button
                        variant='contained'
                        sx={{ mt: 1 }}
                        disabled={ loadingData }
                        onClick={ () => {

                            setIdTipoAudiencia( 0 );
                            setDescripcion( '' );

                            setOpenDialog( true );
                        }}
                    >
                        Agregar
                    </Button>

                </Grid>

            </Grid>

            <Grid container sx={{ mt: 2 }}>

                <Grid size={{ xs: 12 }}>

                    <SearchTextField
                        value={ filtro }
                        label='Buscar por descripción'
                        onChange={ ( value ) => {
                            setFiltro( value );
                            resetPage();
                        }}
                        onClear={ () => resetPage() }
                    />

                </Grid>

            </Grid>

            <TableContainer sx={{ mt: 3, borderRadius: 3 }} component={ Paper }>

                <Table sx={{ minWidth: 500 }}>

                    <TableHead sx={{ ...TableTheadStyle }}>

                        <TableRow sx={{ borderTopLeftRadius: 10, borderTopRightRadius: 10 }}>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%', textAlign: 'center' }}> Id </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'20%' }}> Descripción </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%', textAlign: 'center' }}> Duración <br />(Minutos)</TableCell>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%', textAlign: 'center' }}> Audiencia <br /> oral </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%', textAlign: 'center' }}> Audiencia <br /> tradicional </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%', textAlign: 'center' }}> Audiencia medios <br /> preparatorios </TableCell>
                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'10%', textAlign: 'center' }}> Cita para <br /> sentencia </TableCell>

                            <TableCell style={{ ...TablePaddingStyle, ...TableTheadStyle, width:'15%' }}>  </TableCell>

                        </TableRow>

                    </TableHead>

                    <TableBody>

                        {
                            (
                                rowsPerPage > 0
                                    ?
                                    dataFiltrada.slice( page * rowsPerPage, page * rowsPerPage + rowsPerPage )
                                    :
                                    dataFiltrada
                            )
                                .map( ({ idTipoAudiencia, descripcion, duracion, oral, tradicional, medioPreparatorio, citaSentencia, activo }) => (

                                    <TableRow key={ idTipoAudiencia } >

                                        <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                            { idTipoAudiencia }
                                        </TableCell>

                                        <TableCell>
                                            { descripcion }
                                        </TableCell>

                                        <TableCell sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                                            { duracion !== 0 ? `${ duracion } min` : '' }
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Switch
                                                checked={ oral }
                                                onChange={ (e) => handleChangeChecked( activo, e.target.checked, tradicional, medioPreparatorio, citaSentencia, idTipoAudiencia ) }
                                            />
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Switch
                                                checked={ tradicional }
                                                onChange={ (e) => handleChangeChecked( activo, oral, e.target.checked, medioPreparatorio, citaSentencia, idTipoAudiencia ) }
                                            />
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Switch
                                                checked={ medioPreparatorio }
                                                onChange={ (e) => handleChangeChecked( activo, oral, tradicional, e.target.checked, citaSentencia, idTipoAudiencia ) }
                                            />
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'center' }}>
                                            <Switch
                                                checked={ citaSentencia }
                                                onChange={ (e) => handleChangeChecked( activo, oral, tradicional, medioPreparatorio, e.target.checked, idTipoAudiencia ) }
                                            />
                                        </TableCell>

                                        <TableCell sx={{ textAlign: 'end' }}>

                                            <Switch
                                                checked={ activo }
                                                onChange={ (e) => handleChangeChecked( e.target.checked, oral, tradicional, medioPreparatorio, citaSentencia, idTipoAudiencia ) }
                                            />

                                            <IconButton
                                                color='primary'
                                                aria-label='edit'
                                                component='span'
                                                onClick={ () => {

                                                    setIdTipoAudiencia( idTipoAudiencia );
                                                    setDescripcion( descripcion );
                                                    setDuracion( duracion );

                                                    setOpenDialog( true );
                                                }}
                                            >
                                                <EditIcon />
                                            </IconButton>

                                        </TableCell>

                                    </TableRow>

                                ))
                        }

                        {
                            ( dataFiltrada.length === 0 && !loadingData )
                            ?
                                <TableRow style={{ height: 73 }}>

                                    <TableCell colSpan={ 7 } align='center'>

                                        <Typography variant='caption' color='secondary'> No se encontraron resultados </Typography>

                                    </TableCell>

                                </TableRow>
                            :
                                loadingData
                                &&
                                    <TableRow style={{ height: 73 }}>

                                        <TableCell colSpan={ 7 } align='center'>

                                            <CircularProgress size={ 32 } />

                                        </TableCell>

                                    </TableRow>
                            }

                    </TableBody>

                    <TableFooter>

                        {
                            dataFiltrada.length !== 0
                            &&
                            <TableRow>

                                <TableCell colSpan={ 2 } sx={{ border: 'none' }}>
                                    <Typography variant='body2' color='black' sx={{ fontWeight: 'bold' }}>
                                        Total de registros: { dataFiltrada.length }
                                    </Typography>
                                </TableCell>

                                <TablePagination
                                    sx={{ border: 'none' }}
                                    rowsPerPageOptions={  [ 5, 10, 15, 25, 50, 75, 100, 150, 200, 500] }
                                    colSpan={ 8 }
                                    count={ dataFiltrada.length }
                                    rowsPerPage={ rowsPerPage }
                                    page={ page }

                                    onPageChange={ handleChangePage }
                                    onRowsPerPageChange={ handleChangeRowsPerPage }

                                    ActionsComponent={ TablePaginationActions }

                                    labelRowsPerPage='Filas por página'
                                    labelDisplayedRows={
                                        ({ from, to, count }) => {
                                            return '' + from + '-' + to + ' de ' + count
                                        }
                                    }
                                />

                            </TableRow>
                        }

                    </TableFooter>

                </Table>

            </TableContainer>

            <Dialog open={ openDialog } maxWidth='sm' fullWidth={ true }>

                <DialogContent sx={ DialogContentStyle }>

                    <TextField
                        sx={{ mt: 3 }}
                        label={ 'Descripción' }
                        variant='outlined'
                        multiline
                        rows={ 4 }
                        fullWidth
                        value={ descripcion }
                        onChange={ (e) => setDescripcion( e.target.value ) }
                        slotProps={{
                            input: {
                                autoComplete: 'off'
                            },
                            inputLabel: {
                                shrink: true,
                            }
                        }}
                    />

                    <TextField
                        sx={{ mt: 3 }}
                        label={ 'Duración(Minutos)' }
                        variant='outlined'
                        type='number'
                        fullWidth
                        value={ duracion }
                        onChange={ (e) => setDuracion( Number( e.target.value ) ) }
                        slotProps={{
                            input: {
                                autoComplete: 'off'
                            },
                            inputLabel: {
                                shrink: true,
                            }
                        }}
                    />

                </DialogContent>

                <DialogActions sx={ DialogActionsStyle }>
                    <Button color='secondary' disabled={ loading } onClick={ () => { setOpenDialog( false ); } }> Cancelar </Button>
                    <Button loading={ loading } disabled={ descripcion === '' } onClick={ handleGuardar } variant='contained'> Guardar </Button>
                </DialogActions>

            </Dialog>

        </Layout>

    )
}
